import { render, staticRenderFns } from "./forumCategory.vue?vue&type=template&id=0b9ce74e&scoped=true"
import script from "./forumCategory.vue?vue&type=script&lang=js"
export * from "./forumCategory.vue?vue&type=script&lang=js"
import style0 from "./forumCategory.vue?vue&type=style&index=0&id=0b9ce74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ce74e",
  null
  
)

export default component.exports